module.exports = __webpack_public_path__ + "img/fr.47dca9c0.png";